import { AxiosResponse } from "axios";
import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { toast } from "sonner";
import CatchBlockFunction from "../../../hooks/CatchBlockFunction";
import {
  LoginValidation,
  registerValidation,

  retailRegisterValidation
} from "../../../hooks/Validations";
import { get, post } from "../../../utils/request";
import { IAddCartData } from "../../Products/Cart/types";
import { ILogin, IRegister } from "../types";
import { selectForm, selectRegisterForm } from "./selector";
import { actions } from "./slice";

export function* doLoginRequest(action: {
  payload: {
    callback: (accessToken: string) => void;
    cartData?: IAddCartData[];
  };
}) {
  yield delay(500);

  const form: ILogin = yield select(selectForm);
  const isValid = LoginValidation(form);
  if (!isValid) {
    return;
  }
  const data = {
    email: form.email,
    password: btoa(form.password),
    cartData: action?.payload?.cartData || [],
  };

  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield post("auth/user/login", data);
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield put(actions.setIsLogin(true));
    yield put(actions.setToken(response.data.data.accessToken));

    yield call(action?.payload?.callback, response.data.data.accessToken);
  } catch (error) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doRegisterRequest(action: {
  payload: { callback: () => void };
}) {
  yield delay(500);

  const form: IRegister = yield select(selectRegisterForm);
  const isValid = registerValidation(form);
  if (!isValid) {
    return;
  }
  const data = {
    email: form.email,
    firstName: form.firstName,
    lastName: form.lastName,
    japaneseFirstName: form.japaneseFirstName,
    japaneseLastName: form.japaneseLastName,
    mobileNumber: form.mobileNumber,
    password: btoa(form.password),
    streetAddress: form.streetAddress,
    postCode: form.postCode,
    prefectures: form.prefectures,
    companyName: form.companyName,
    companyName_H: form.companyName_H,
    companyLocation: form.companyLocation,
    companyLocation_H: form.companyLocation_H,
    companyDepartmentName: form.companyDepartmentName,
    companyDepartmentName_H: form.companyDepartmentName_H,
    companyRepresentativeName: form.companyRepresentativeName,
    companyRepresentativeName_H: form.companyRepresentativeName_H,
    companyMobileNumber: form.companyMobileNumber,
    companyFaxNumber: form.companyFaxNumber,
  };

  try {
    yield put(actions.setButtonLoading(true));

    const response: AxiosResponse = yield post("public/user/sign-up", data);
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action.payload.callback);
  } catch (error) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetMeProfileRequest(action: {
  payload: { token: string; callback: () => void };
}) {
  yield delay(500);
  if (action.payload.token) {
    try {
      yield put(actions.setLoading(true));
      const response: AxiosResponse = yield call(get, "/auth/user/me");
      if (response && !response.data) {
        toast.error(response.data.message);
        return;
      }
      yield put(actions.setProfileData(response.data.data));
      yield put(actions.setIsLogin(true));
      yield put(actions.setLoading(true));
      yield call(action?.payload?.callback);
    } catch (error) {
      yield put(actions.setLoading(false));
      CatchBlockFunction(error);
    }
  } else {
    yield put(actions.setLoading(false));
    yield put(actions.setIsLogin(false));
  }
}

// -------------Retail Login---------------------
export function* doRetailLoginRequest(action: {
  payload: { callback: (accessToken: string) => void };
}) {
  yield delay(500);

  const form: ILogin = yield select(selectForm);

  const isValid = LoginValidation(form);
  if (!isValid) {
    return;
  }

  const data = {
    email: form.email,
    password: btoa(form.password),
  };

  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield post("auth/retailer/login", data); // Use your retail login endpoint
    yield put(actions.setButtonLoading(false));

    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }

    toast.success(response.data.message);
    yield put(actions.setIsLogin(true));
    yield put(actions.setToken(response.data.data.accessToken));
    yield call(action?.payload?.callback, response.data.data.accessToken);
  } catch (error) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}
// ---------------------------------------------

// ----------Retail Register ----------------------
export function* doRetailRegisterRequest(action: {
  payload: { callback: () => void };
}) {
  yield delay(500);

  const form: IRegister = yield select(selectRegisterForm);
  const isValid = retailRegisterValidation(form);
  if (!isValid) return;

  const data = {
    firstName: form.firstName,
    lastName: form.lastName,
    japaneseFirstName: form.japaneseFirstName,
    japaneseLastName: form.japaneseLastName,
    postCode: form.postCode,
    prefectures: form.prefectures,
    streetAddress: form.streetAddress,
    mobileNumber: form.mobileNumber,
    email: form.email,
    password: btoa(form.password),
    companyName: form.companyName,
    companyName_H: form.companyName_H,
    companyLocation: form.companyLocation,
    companyLocation_H: form.companyLocation_H,
    companyDepartmentName: form.companyDepartmentName,
    companyDepartmentName_H: form.companyDepartmentName_H,
    companyRepresentativeName: form.companyRepresentativeName,
    companyRepresentativeName_H: form.companyRepresentativeName_H,
    companyMobileNumber: form.companyMobileNumber,
    companyFaxNumber: form.companyFaxNumber,
  };

  try {
    yield put(actions.setButtonLoading(true));
    const response: AxiosResponse = yield post("public/retailer/sign-up", data);
    yield put(actions.setButtonLoading(false));

    if (!response?.data) {
      toast.error(response.data.message);
      return;
    }

    toast.success(response.data.message);
    yield put(actions.setIsLogin(true));
    yield call(action?.payload?.callback);
  } catch (error) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}

// -----------------------------------------------------

export function* AuthRepoSaga() {
  yield takeLatest(actions.doLogin, doLoginRequest);
  yield takeLatest(actions.doRegister, doRegisterRequest);
  yield takeLatest(actions.doGetProfile, doGetMeProfileRequest);

  // ------------------------------------------------------
  yield takeLatest(actions.doRetailLogin, doRetailLoginRequest);
  yield takeLatest(actions.doRetailRegister, doRetailRegisterRequest);
}
